<template>
    <v-card style="padding: 0px 10px;">
        <v-toolbar dark dense color="tertiary" >
            <v-toolbar-title style="white-space: normal;height: auto">
                {{this.deleteTitle}}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn title="取消" icon dark @click.native="closeDelete">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text style="font-size: 1.1rem;margin-top: 5px" v-html="this.deleteContent"></v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDelete">取消</v-btn>
            <v-btn  @click.native="confirmDelete">確定</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "DeleteInfoDialog",
        props:['deleteTitle','deleteContent'],
        methods:{
            confirmDelete(){
                this.$emit('confirmDelete');
            },
            closeDelete(){
                this.$emit('closeDelete');
            }
        }
    }
</script>

<style scoped>

</style>